import { PlaceDetails } from '../types';

export const googleToInternalPlaceDetails = (
  details: google.maps.places.Place
): PlaceDetails => {
  const { addressComponents: components } = details;
  const componentMap = new Map<string, google.maps.places.AddressComponent>();

  components?.forEach((component) => {
    component.types.forEach((type) => {
      if (!componentMap.has(type)) {
        componentMap.set(type, component);
      }
    });
  });

  const addressLine1 = details.displayName;
  const city =
    componentMap.get('locality') ||
    componentMap.get('administrative_area_level_3');
  const borough = componentMap.get('sublocality');
  const state = componentMap.get('administrative_area_level_1');
  const zip = componentMap.get('postal_code');
  const country = componentMap.get('country');
  const county = componentMap.get('administrative_area_level_2');

  return {
    address: addressLine1 || '',
    city: city?.longText || borough?.longText || '',
    state: state?.shortText ?? '',
    zip: zip?.longText ?? '',
    country: country?.shortText ?? '',
    county: county?.longText ?? '',
  };
};
